export default __webpack_public_path__ + "static/media/safetyok2.9f2700a3.jpg";